import React, { useEffect, useState } from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
// import homeLogo from "../../Assets/home-main.png"; // Removed homeLogo import
// import Particle from "../Particle"; // Removed Particle import
import Home2 from "./Home2";
import Type from "./Type";
// import myPhoto from '../../Assets/my-photo.jpg'; // Place the provided image in Assets as my-photo.jpg

function Home() {
  // Track theme using state and effect
  const [isDark, setIsDark] = useState(() =>
    typeof window !== 'undefined' && document.body.classList.contains('dark-theme')
  );
  useEffect(() => {
    const observer = new MutationObserver(() => {
      setIsDark(document.body.classList.contains('dark-theme'));
    });
    observer.observe(document.body, { attributes: true, attributeFilter: ['class'] });
    return () => observer.disconnect();
  }, []);

  const bgStyle = isDark
    ? {
        background: 'linear-gradient(120deg, #0f172a 0%, #1e293b 100%)',
      }
    : {
        background: 'linear-gradient(120deg, #e0e7ff 0%, #c7d2fe 100%)',
      };
  return (
    <section>
      <Container fluid className="home-section" id="home" style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'relative',
        overflow: 'hidden',
        ...bgStyle,
      }}>
        {/* Animated background shapes */}
        <div style={{
          position: 'absolute',
          top: 0, left: 0, width: '100%', height: '100%',
          zIndex: 0,
          pointerEvents: 'none',
        }}>
          <svg width="100%" height="100%" style={{ position: 'absolute', left: 0, top: 0 }}>
            <circle cx="10%" cy="20%" r="60" fill={isDark ? "#33415533" : "#3b82f622"} />
            <circle cx="80%" cy="80%" r="90" fill={isDark ? "#1e40af33" : "#60a5fa22"} />
            <circle cx="60%" cy="30%" r="40" fill={isDark ? "#64748b33" : "#a5b4fc22"} />
          </svg>
        </div>
        <Container className="glass-card" style={{
          zIndex: 1,
          padding: '3.5rem 2.5rem',
          borderRadius: 24,
          boxShadow: isDark ? '0 12px 40px 0 rgba(30,34,54,0.25)' : '0 12px 40px 0 rgba(80,120,200,0.18)',
          maxWidth: 800,
          margin: '0 auto',
          textAlign: 'center',
          background: isDark ? 'rgba(30,34,54,0.85)' : 'rgba(220,230,255,0.85)',
          color: isDark ? '#fff' : '#222',
        }}>
          <Row className="align-items-center">
            <Col xs={12}>
              <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginBottom: 24 }}>
                {/* <div style={{ margin: '0 auto 18px auto', width: 140, height: 140, borderRadius: '50%', overflow: 'hidden', boxShadow: '0 4px 24px #3b82f633', border: '4px solid #a5b4fc55', background: '#fff8' }}>
                  <img src={myPhoto} alt="Meet Jain" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                </div> */}
                <h1 style={{ fontSize: '3.2em', fontWeight: 800, marginBottom: 10, letterSpacing: '-1px', color: isDark ? '#60a5fa' : '#2563eb' }}>
                  Hi, I'm <span className="purple" style={{ color: isDark ? '#a5b4fc' : '#7c3aed' }}>Meet Jain</span>
                </h1>
                {/* <div style={{ fontSize: '1.5em', fontWeight: 500, marginBottom: 18, color: isDark ? '#cbd5e1' : '#334155', opacity: 0.85 }}>
                  Transforming ideas into seamless digital experiences
                </div> */}
                <div style={{ fontSize: '1.3em', marginBottom: 24, color: isDark ? '#60a5fa' : '#3b82f6', fontWeight: 600 }}>
                  <Type />
                </div>
                <div style={{ display: 'flex', gap: 16, justifyContent: 'center' }}>
                  <Button
                    variant="primary"
                    href="/stats"
                    style={{
                      fontWeight: 600,
                      fontSize: '1.1em',
                      padding: '0.7em 2.2em',
                      borderRadius: 12,
                      border: 'none',
                      boxShadow: isDark ? '0 2px 12px #1e293b99' : '0 2px 12px #3b82f633',
                      transition: 'background 0.2s',
                      color: '#fff',
                    }}
                  >
                    View Coding Stats
                  </Button>
                  <Button
                    variant="outline-primary"
                    href="#about"
                    style={{
                      fontWeight: 600,
                      fontSize: '1.1em',
                      padding: '0.7em 2.2em',
                      borderRadius: 12,
                      border: '2px solid #60a5fa',
                      color: isDark ? '#a5b4fc' : '#2563eb',
                      background: 'transparent',
                    }}
                  >
                    Contact Me
                  </Button>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </Container>
      <Home2 />
    </section>
  );
}

export default Home;
